import React from "react";
import { CONTACT_EMAIL } from "../../config/site";

/**
 * Banda de contacto al cierre de la home pública.
 */
const ContactBand = () => (
	<section id="contacto" className="anchor-target bg-ink py-16 text-white lg:py-[105px]">
		<div className="shell grid items-end gap-8 lg:grid-cols-[1fr_auto] lg:gap-20">
			<div className="lg:col-span-2">
				<p className="eyebrow !text-white/60">Contacto</p>
			</div>

			<h2 className="display-2 max-w-[850px]">
				¿Necesitás información sobre una marca o promoción?
			</h2>

			<a className="button button--light w-full sm:w-auto" href={ `mailto:${CONTACT_EMAIL}` }>
				Contacto comercial <span aria-hidden="true">→</span>
			</a>
		</div>
	</section>
);

export default ContactBand;
